// Top toolbar for the Prospección page: layer toggles, operator filter, KMZ upload, CSV import.
import React from 'react';
import { Radio, Upload, Loader2 } from 'lucide-react';
import CsvImport from '../CsvImport';

const OP_BUTTONS = [
  { key: 'ORANGE',      color: '#ff6b00', label: 'ORANGE' },
  { key: 'WILLIAM_VDF', color: '#e60000', label: 'VDF' },
  { key: 'WILLIAM_OSP', color: '#3b82f6', label: 'OSP' },
  { key: 'AVE_OSP',     color: '#10b981', label: 'AVE' },
];

export const LayersToggle = ({
  showNodes, setShowNodes, nodeStats,
  showTotemTowers, setShowTotemTowers, towersStats,
  nodesLoading,
  fileRef, onFile, onImported,
}) => (
  <div className="flex gap-3 flex-wrap items-center">
    {nodeStats && (
      <button onClick={() => setShowNodes((s) => !s)} data-testid="btn-toggle-nodes"
        className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full font-bold text-xs border transition-all ${
          showNodes ? 'bg-[#A3FF12]/10 text-[#A3FF12] border-[#A3FF12]/40' : 'bg-white/5 text-white/60 border-white/10'
        }`}>
        <Radio size={14}/>
        {showNodes ? 'Ocultar' : 'Mostrar'} nodos
        <span className="bg-[#A3FF12]/20 text-[#A3FF12] px-1.5 py-0.5 rounded-full text-[10px]">{nodeStats.total.toLocaleString('es-ES')}</span>
        {nodesLoading && <Loader2 size={12} className="animate-spin"/>}
      </button>
    )}
    {towersStats && (
      <button onClick={() => setShowTotemTowers((s) => !s)} data-testid="btn-toggle-towers"
        className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full font-bold text-xs border transition-all ${
          showTotemTowers ? 'bg-purple-500/20 text-purple-300 border-purple-500/40' : 'bg-white/5 text-white/60 border-white/10'
        }`}>
        🗼 {showTotemTowers ? 'Ocultar' : 'Mostrar'} torres
        <span className="bg-purple-500/20 text-purple-300 px-1.5 py-0.5 rounded-full text-[10px]">{towersStats.total.toLocaleString('es-ES')}</span>
      </button>
    )}
    <input ref={fileRef} type="file" accept=".kmz,.kml" className="hidden" onChange={onFile}/>
    <CsvImport entity="sites" onImported={onImported}/>
  </div>
);

export const OperatorFilter = ({ nodeStats, opFilter, setOpFilter, visibleCount }) => {
  if (!nodeStats) return null;
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2 bg-black/40 border border-white/10 rounded-xl px-3 py-2 text-xs">
      <span className="font-bold text-white/70 mr-1">Operador:</span>
      <button onClick={() => setOpFilter(null)}
        className={`flex items-center gap-1 px-2 py-1 rounded-full border transition-colors ${
          opFilter === null ? 'bg-[#A3FF12]/20 text-[#A3FF12] border-[#A3FF12]/40' : 'text-white/60 border-white/10 hover:text-white'
        }`}>
        Todos <span className="text-[10px] opacity-70">({nodeStats.total.toLocaleString('es-ES')})</span>
      </button>
      {OP_BUTTONS.map((x) => {
        const active = opFilter === x.key;
        const count = nodeStats.by_operator?.[x.key] || 0;
        return (
          <button key={x.key} onClick={() => setOpFilter(active ? null : x.key)} data-testid={`op-filter-${x.label.toLowerCase()}`}
            className={`flex items-center gap-1 px-2 py-1 rounded-full border transition-colors ${
              active ? 'bg-white/10 text-white border-white/40 ring-1 ring-[#A3FF12]/30' : 'text-white/60 border-white/10 hover:text-white'
            }`}>
            <span style={{ background: x.color, width: 8, height: 8, borderRadius: '50%', display: 'inline-block' }}/>
            {x.label}
            {count > 0 && <span className="text-[10px] opacity-70">({count.toLocaleString('es-ES')})</span>}
          </button>
        );
      })}
      <span className="text-white/40 ml-auto">{visibleCount} visibles</span>
    </div>
  );
};
